export const firebaseConfigAppCheck = {
  /** Engages/disengages App Check mode */
  appCheckEnabled: false,
  /** App Check site key - reCAPTCHA v3 */
  siteKeyToken: '6LcmMy8hAAAAAF7vPvLNM8uzux8LTuO4PSRHkHxU',
};
